import getConfig from "next/config"
import { PHASE_PRODUCTION_BUILD , PHASE_PRODUCTION_SERVER, PHASE_DEVELOPMENT_SERVER} from "next/dist/shared/lib/constants"

export enum Region {
    CN="zh-cn",
    GLOBAL="global"
}
export enum AppEnv {
  Dev = "dev",
  Staging = "staging",
  Prod = "prod",
}
export interface IPublicRuntimeConfig{
  version: string;
  appName: string;
  phase: string;
  isLocal: boolean;
  buildEnv: string;
  env: AppEnv;
  region: Region;
  isDevelopment: boolean;
  buildTime: number;
}
export const publicRuntimeConfig:IPublicRuntimeConfig = getConfig() ? getConfig().publicRuntimeConfig : {
    version:"",
    phase:PHASE_DEVELOPMENT_SERVER
}
export const isBuild = publicRuntimeConfig.phase === PHASE_PRODUCTION_BUILD;
export const isServer = publicRuntimeConfig.phase === PHASE_PRODUCTION_SERVER;


export const isDev = publicRuntimeConfig.phase === PHASE_DEVELOPMENT_SERVER;

export function getBuildTime(){
    return isDev ? Date.now() : getConfig().publicRuntimeConfig.buildTime || 1;
}